import { render, staticRenderFns } from "./MyGame.vue?vue&type=template&id=04bbd12a&scoped=true&"
import script from "./MyGame.vue?vue&type=script&lang=js&"
export * from "./MyGame.vue?vue&type=script&lang=js&"
import style0 from "./MyGame.vue?vue&type=style&index=0&id=04bbd12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bbd12a",
  null
  
)

export default component.exports